import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.37 12.93L6 11.48L11.75 6L17.5 11.48L16.13 12.93L11.75 8.76L7.37 12.93ZM6 16.55L7.37 18L11.75 13.83L16.13 18L17.5 16.55L11.75 11.07L6 16.55Z" fill={ fill || 'currentColor' } />
    </svg>
);
